








































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import ScorecardSubpage from '@/pages/scorecard/components/ScorecardSubpage.vue'
import {Action, Getter} from 'vuex-class'
import {ScorecardEntity} from '@/entities/scorecard'
import {IResponse} from '@/entities'
import {seeBadge} from '@/api/scorecard'
import {embedded} from '@/utils/react-native-webview'
import ScorecardResponseTile from '@/components/ScorecardResponseTile.vue'

@Component<ScorecardBadgeDetail>({
    components: {ScorecardResponseTile, ScorecardSubpage}
})
export default class ScorecardBadgeDetail extends Vue {
    @Prop({type: String})
    public value !: string // the room to improve badge

    @Prop({type: String, default: null})
    public teamMemberUserId !: string // view another users scorecard / my teams

    @Getter public slide !: string
    @Getter public scorecard!: ScorecardEntity
    @Getter public scorecardResponsesMap!: { [value: string]: IResponse[] }
    @Getter public badgeTotalMap!: { [value: string]: { pastMonth, total } }
    @Getter public scorecardOutdated!: boolean
    @Getter
    hasNetworkConnection!:boolean

    @Action public loadScorecard
    @Action public loadResponsesForBadge
    @Action public loadTotalCountForBadge
    @Action public setSlide

    public slideName = 'left'
    public loading = true

    public async beforeMount() {
        if (this.scorecardOutdated) {
            await this.loadScorecard(this.teamMemberUserId ?? null)
        }

        this.slideName = this.slide
    }

    public mounted() {
        this.load()
    }

    public async load() {
        this.loadTotalCountForBadge({type: 'positive', value: this.value, userId: this.teamMemberUserId ?? null})

        await this.loadResponsesForBadge({type: 'positive', value: this.value})
        this.loading = false

        // update the last seen timestamp of this badge
        if (!this.teamMemberUserId && this.scorecard.badges.positive[this.value].countUnseen && this.hasNetworkConnection) {
            await seeBadge(this.value, 'positive')
            this.loadScorecard()
        }
    }

    public get mapKey() {
        return `${this.value}_positive`
    }

    public get badgeLabel() {
        return this.scorecard.badges.positive[this.value].label
    }

    public get badgeId() {
        return this.scorecard.badges.positive[this.value].badgeId
    }

    public get responses() {
        return this.scorecardResponsesMap &&
            this.scorecardResponsesMap[this.mapKey] || []
    }

    public get totalCount() {
        return this.badgeTotalMap && this.badgeTotalMap[this.mapKey] &&
            this.badgeTotalMap[this.mapKey].total || 0
    }

    public get calendarMonthCount() {
        return this.badgeTotalMap && this.badgeTotalMap[this.mapKey] &&
            this.badgeTotalMap[this.mapKey].pastMonth || 0
    }

    public get embedded() {
        return embedded
    }
}
